(() => {
  const initReferences = (root) => {
    if (!root || root.dataset.somaReferencesReady === 'true') return;

    const tabs = [...root.querySelectorAll('[data-soma-reference-tab]')];
    const panels = [...root.querySelectorAll('[data-soma-reference-panel]')];

    const activate = (name) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.somaReferenceTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.somaReferencePanel !== name;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.dataset.somaReferenceTab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[(index + direction + tabs.length) % tabs.length];
        activate(next.dataset.somaReferenceTab);
        next.focus();
      });
    });

    root.dataset.somaReferencesReady = 'true';
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-soma-references]').forEach(initReferences);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
